import DayDetailsCellRenderer from "./DayDetailsCellRenderer";
import {imgPath} from "../../atBrowserUtils"

export default class TaskDayCellRenderer extends DayDetailsCellRenderer {
    constructor(available, cssBaseClass, cssTopBorderClass, completed) {
        super(cssBaseClass, cssTopBorderClass);
        this.available = available;
        this.completed = completed;
    }

    getCellClassName(cell) {
        var baseClass = DayDetailsCellRenderer.prototype.getCellClassName.call(this, cell);
        return baseClass + (this.completed ? " completedTimeText" : "");
    }

    buildContent(cell) {
        var formatedTime = this.parseTime(cell.getValue().actuals);
        if (this.available && cell.getValue().hasComment) {
            //workaround: positioning of showComments element ignores td paddings under ie
            cell.getCellEl().style.padding = 0;
            var div = document.createElement("div");
            div.className = "showCommentsContainer";
            div.innerHTML = formatedTime;

            var commentsImg = document.createElement("img");
            commentsImg.className = "showComments";
            commentsImg.src = imgPath("lock_tt/small-comment.gif");

            cell.getRow().getTable().getCommentsController().registerCommentsEl(commentsImg, cell);

            div.appendChild(commentsImg);
            cell.getCellEl().appendChild(div);
        }
        else {
            cell.getCellEl().innerHTML = formatedTime;
        }
    }

    addTooltip(cell) {
        cell.getRow().getTable().getTooltipController().addTaskDayTooltip(cell.getCellEl(),
            cell.getRow().getParentRow().getHeaderCell().getValue().id,
            cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date,
            cell.getRow().getHeaderCell().getValue(),
            cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/TaskDayCellRenderer.js